import { Box, Button } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { FaLine } from "react-icons/fa6";
import { thirdPartyBind } from "../../../api/postApi";
import { waitTime } from "../../../utils/waitTime";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { notice } from "../../../redux/action/action";
import { useTranslation } from "react-i18next";

const LineBind = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const [buttonLoading, setButtonLoading] = useState(false);

  const isMemberInfo = useSelector((state) => state.isMemberInfo);

  const { thirdPartyAccount } = isMemberInfo || {};

  // 判斷是否已綁定 LINE
  // 判斷有無 line 物件且 status=1 即為已綁定
  const already_bind_line = useMemo(() => {
    return !!(thirdPartyAccount?.line && thirdPartyAccount.line.status === 1);
  }, [thirdPartyAccount]);

  const test = isMemberInfo?.test;
  const is_machine = isMemberInfo?.is_machine;

  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();

  const bindLine = async () => {
    const lineUrl = "https://liff.line.me/2007099270-KGRpzqEN";

    await setButtonLoading(true);

    await waitTime(1000);

    window.location.href = lineUrl;
    // await thirdPartyBind();
    await setButtonLoading(false);
  };

  useEffect(() => {
    //賴網址回調會產生這倆個參數在查詢字串裡面
    const bind_type = searchParams.get("bind_type");
    const bind_id = searchParams.get("bind_id");

    const fetchData = async () => {
      setButtonLoading(true);

      await thirdPartyBind({ bind_type, bind_id }).then((res) => {
        dispatch(
          notice({
            title: i18n("綁定成功！！"),
            content: "",
            type: "success",
          })
        );
        dispatch({ type: "GET_MEMBER_DATA" });
      });

      setButtonLoading(false);
    };

    if (bind_type && bind_id && !already_bind_line) {
      fetchData();
    }
  }, [searchParams, dispatch, already_bind_line]);

  return (
    !already_bind_line &&
    test === 0 &&
    is_machine === 0 && (
      <Box
        mt="10px"
        display="flex"
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Button
          bg="#06C655"
          _hover={{
            bg: "#06C655",
          }}
          _active={{
            bg: "#06C655",
          }}
          leftIcon={<FaLine />}
          w="100%"
          isLoading={buttonLoading}
          onClick={bindLine}
        >
          {i18n("LINE綁定帳戶")}
        </Button>
      </Box>
    )
  );
};

export default LineBind;
